import { Logger } from '@/lib/log.ts';
import { writable } from 'svelte/store';

const log = Logger('header.DstSpStore');

const spStore = writable(false);
let timeout: ReturnType<typeof setTimeout>;
const delay = 500;

/**
 * Check if _sp_ object is attached to the window
 */
function checkForSp(): void {
	if (window._sp_) {
		// Update the store when _sp_ is available
		spStore.set(true);
		log.debug('SourcePoint is available', spStore);
	} else {
		// Retry after a delay
		timeout = setTimeout(checkForSp, delay);
	}
}

/**
 * Resurface the privacy manager using the SourcePoint script
 * @param sourcePointId
 */
function resurfacePrivacyManager(sourcePointId: string): void {
	window._sp_.loadPrivacyManagerModal(sourcePointId);
}

/**
 * Stop the check
 * @param spStore
 */
function stopSpCheck(spStore: boolean): void {
	// Set a timeout to stop the check after 5 seconds
	setTimeout(() => {
		if (!spStore) {
			log.debug('SourcePoint is not available', spStore);
			clearTimeout(timeout);
		}
	}, 5000);
}

export { checkForSp, resurfacePrivacyManager, spStore, stopSpCheck };
